import React from "react";
import UpdatedShareContainer from "../components/UI/Views/permission/UpdatedShareContainer";

export default function ShareAccess() {
  return <UpdatedShareContainer maxHeight={"calc(100vh - 275px)"} />;
}
